export default __webpack_public_path__ + "static/2-d019cfe998d060d47def10bf99ef6274.jpeg";